import classNames from 'classnames';
import { HTMLProps } from 'react';

export const Form = ({ className, ...props }: HTMLProps<HTMLFormElement>) => (
  <form className={classNames('relative w-full grid gap-4 md:gap-6', className)} {...props} />
);
